import React from "react";
import { Col, Row } from "react-bootstrap";
import {
    SiIntellijidea,
    SiPostman,
    SiRender,
    SiVercel,
    SiUbuntu,
    SiGithub,
    SiGitlab,
    SiVisualstudiocode,
    SiSwagger,
    SiDocker,
} from "react-icons/si";

function Toolstack() {
    return (
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
            <Col xs={4} md={2} className="tech-icons">
                <SiUbuntu />
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiIntellijidea />
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiPostman />
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiVercel />
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiRender />
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiGithub />
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiGitlab />
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiVisualstudiocode />
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiSwagger />
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiDocker />
            </Col>
        </Row>
    );
}

export default Toolstack;
